import { render, staticRenderFns } from "./CardPropertyTable.vue?vue&type=template&id=373d6c0c&"
import script from "./CardPropertyTable.vue?vue&type=script&lang=js&"
export * from "./CardPropertyTable.vue?vue&type=script&lang=js&"
import style0 from "./CardPropertyTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QInput,QIcon,QTable,QTr,QTh,QTooltip,QTd,QBtn,QPagination,QSpinnerGears,QInnerLoading} from 'quasar'
component.options.components = Object.assign({QField,QInput,QIcon,QTable,QTr,QTh,QTooltip,QTd,QBtn,QPagination,QSpinnerGears,QInnerLoading}, component.options.components || {})
